module.exports = __webpack_public_path__ + "static/media/fbe-engraving-pattern-black10.479443e6.svg";